import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronDownIcon, MenuIcon } from 'lucide-react';
import { useStory } from './StoryContext';
export const Navigation = () => {
  const navigate = useNavigate();
  const {
    isLoggedIn,
    setIsLoggedIn
  } = useStory();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && buttonRef.current && !menuRef.current.contains(event.target as Node) && !buttonRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_email');
    setIsLoggedIn(false);
    setIsMenuOpen(false);
    navigate('/');
  };
  return <nav className="bg-[#FFFBF6] shadow-sm border-b border-[#E5C1A9]" data-id="element-796">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-797">
        <div className="flex justify-between items-center h-20" data-id="element-798">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-799">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aqyBJPeaT2JTUeBCPrAbk2/Story_Bunny_Logo_Updated_Font_Color.png" alt="Story Bunny Logo" className="h-32 w-auto" data-id="element-800" />
          </Link>
          {/* Navigation Links */}
          <div className="flex items-center space-x-4" data-id="element-801">
            <Link to="/garden" className="px-4 py-2 text-[#6B4B3E] hover:bg-[#FFF0E6] rounded-full transition-colors" data-id="element-802">
              Story Garden
            </Link>
            <div className="relative" data-id="element-803">
              <button ref={buttonRef} onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 text-white bg-[#D4A088] rounded-full hover:bg-[#C28B73] transition-colors" data-id="element-804">
                <MenuIcon size={20} data-id="element-805" />
              </button>
              <div ref={menuRef} className={`absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border border-[#E5C1A9] transition-all ${isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'} z-50`} data-id="element-806">
                <div className="py-2" data-id="element-807">
                  {!isLoggedIn && <>
                      <Link to="/create-account" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2 text-[#6B4B3E] hover:bg-[#FFFBF6] transition-colors" data-id="element-808">
                        Create Account
                      </Link>
                      <Link to="/login" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2 text-[#6B4B3E] hover:bg-[#FFFBF6] transition-colors" data-id="element-809">
                        Log In
                      </Link>
                    </>}
                  <Link to="/pricing" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2 text-[#6B4B3E] hover:bg-[#FFFBF6] transition-colors" data-id="element-810">
                    Purchase Credit
                  </Link>
                  <Link to="/story-ideas-tips" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2 text-[#6B4B3E] hover:bg-[#FFFBF6] transition-colors" data-id="element-811">
                    Story Ideas & Tips
                  </Link>
                  <Link to="/faq" onClick={() => setIsMenuOpen(false)} className="block px-4 py-2 text-[#6B4B3E] hover:bg-[#FFFBF6] transition-colors" data-id="element-812">
                    FAQ
                  </Link>
                  {isLoggedIn && <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-red-600 hover:bg-red-50 transition-colors border-t border-[#E5C1A9]" data-id="element-813">
                      <span data-id="element-814">Log Out</span>
                      <span className="block text-xs text-red-400 mt-0.5" data-id="element-815">
                        {localStorage.getItem('user_email')}
                      </span>
                    </button>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>;
};